var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-layout", {
    attrs: { moduleCode: _vm.moduleCode },
    scopedSlots: _vm._u(
      [
        {
          key: "main",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "container-fluid", class: _vm.containerClass },
                [
                  _c("div", { staticClass: "row vh-100" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-none d-md-block p-0",
                        class: [
                          _vm.hasDefaultSlot ? "col-md-5 col-lg-6" : "col-12",
                        ],
                      },
                      [_c("sidebar-user")],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasDefaultSlot
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-7 col-lg-6 ml-sm-auto px-4 d-flex align-items-sm-center pt-4 pt-sm-0",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row w-100 justify-content-center no-gutters",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-10" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row d-sm-none" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col text-center mb-4",
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "logo-mobile",
                                                attrs: {
                                                  to: {
                                                    name: `${_vm.pageID}.home`,
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.assetsPathGlobalPlatform(
                                                      "/logo-mobile.svg"
                                                    ),
                                                    alt: "Logo mobile",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._t("default"),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }